import Swiper from 'swiper';
import { Keyboard, Autoplay } from 'swiper/modules';
import { onDomReady } from '../../JavaScript/on-dom-ready';

onDomReady(() => {
  for (const slider of document.getElementsByClassName('slider--hero')) {
    const swiperElement = slider.querySelector('.swiper');
    const progressBar = slider.querySelector('.slider-progress-bar');
    if (!(swiperElement instanceof HTMLElement)) {
      continue;
    }

    new Swiper(swiperElement, {
      modules: [Keyboard, Autoplay],
      spaceBetween: 16,
      slidesPerView: 1,
      autoHeight: true,
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
      },
      on: {
        autoplayTimeLeft(s: Swiper, time: number, progress: number) {
          const percentage = (1 - progress) * 100;
          if (progressBar instanceof HTMLElement) {
            progressBar.style.width = percentage + '%';
          }
        },
      },
    });
  }
});
